/**
 * AUTO-GENERATED FILE. DO NOT EDIT MANUALLY.
 * Generated by scripts/generateAnalyticsEvents.js
 * Run `pnpm gen:analytics` to regenerate.
 */

const analyticsEventMapLiteral = {
  assetClassesAddSummary: 'asset_classes_summary_add',
  assetClassesEditSummary: 'asset_classes_summary_edit',
  assetClassesInherit: 'asset_classes_inherit',
  assetClassesPageListArchive: 'asset_classes_page_list_archive',
  assetClassesPageListPageNext: 'asset_classes_page_list_page_next',
  assetClassesPageListPageNumber: 'asset_classes_page_list_page_number',
  assetClassesPageListPagePrevious: 'asset_classes_page_list_page_previous',
  billingManagementDownload: 'billing_management_download',
  billingManagementFilterBillingScheduleSelect: 'billing_management_filter_billing_schedule_select',
  billingManagementFilterDateFromSelect: 'billing_management_filter_date_from_select',
  billingManagementFilterDateToSelect: 'billing_management_filter_date_to_select',
  billingManagementFilterStateSelect: 'billing_management_filter_state_select',
  billingScheduleAddComplete: 'billing_schedule_add_complete',
  billingScheduleAddInit: 'billing_schedule_add_init',
  billingScheduleAddSummary: 'billing_schedule_add_summary',
  billingScheduleEditComplete: 'billing_schedule_edit_complete',
  billingScheduleEditInit: 'billing_schedule_edit_init',
  billingScheduleEditSummary: 'billing_schedule_edit_summary',
  bulkTraderDetailCancel: 'bulk_trader_detail_cancel',
  bulkTraderDetailComplete: 'bulk_trader_detail_complete',
  bulkTraderDetailDownloadAllocationFile: 'bulk_trader_detail_download_allocation_file',
  bulkTraderDetailDownloadAllocationFileNew: 'bulk_trader_detail_download_allocation_file_new',
  bulkTraderDetailDownloadBulkTradeFile: 'bulk_trader_detail_download_bulk_trade_file',
  bulkTraderDetailDownloadBuyFile: 'bulk_trader_detail_download_buy_file',
  bulkTraderDetailDownloadMutualFundFile: 'bulk_trader_detail_download_mutual_fund_file',
  bulkTraderDetailDownloadPtfAllocationFile: 'bulk_trader_detail_download_ptf_allocation_file',
  bulkTraderDetailDownloadPtfFile: 'bulk_trader_detail_download_ptf_file',
  bulkTraderDetailDownloadSellFile: 'bulk_trader_detail_download_sell_file',
  bulkTraderDetailError: 'bulk_trader_detail_error',
  bulkTraderDetailSave: 'bulk_trader_detail_save',
  bulkTraderDetailTransition: 'bulk_trader_detail_transition',
  bulkTraderDetailUpdate: 'bulk_trader_detail_update',
  bulkTraderPageListCreate: 'bulk_trader_page_list_create',
  bulkTraderPageListDownloadAllocationFile: 'bulk_trader_page_list_download_allocation_file',
  bulkTraderPageListDownloadAllocationFileNew: 'bulk_trader_page_list_download_allocation_file_new',
  bulkTraderPageListDownloadBulkTradeFile: 'bulk_trader_page_list_download_bulk_trade_file',
  bulkTraderPageListDownloadBuyFile: 'bulk_trader_page_list_download_buy_file',
  bulkTraderPageListDownloadMutualFundFile: 'bulk_trader_page_list_download_mutual_fund_file',
  bulkTraderPageListDownloadPtfAllocationFile: 'bulk_trader_page_list_download_ptf_allocation_file',
  bulkTraderPageListDownloadPtfFile: 'bulk_trader_page_list_download_ptf_file',
  bulkTraderPageListDownloadSellFile: 'bulk_trader_page_list_download_sell_file',
  bulkTraderPageListPageNext: 'bulk_trader_page_list_page_next',
  bulkTraderPageListPageNumber: 'bulk_trader_page_list_page_number',
  bulkTraderPageListPagePrevious: 'bulk_trader_page_list_page_previous',
  bulkTraderPageListRowSelect: 'bulk_trader_page_list_row_select',
  bulkTraderRunAbandon: 'bulk_trader_run_abandon',
  bulkTraderRunComplete: 'bulk_trader_run_complete',
  bulkTraderRunError: 'bulk_trader_run_error',
  bulkTraderRunInit: 'bulk_trader_run_init',
  bulkTraderRunSummary: 'bulk_trader_run_summary',
  clientManagementClientsSelect: 'client_management_clients_select',
  clientManagementCorporationsSelect: 'client_management_corporations_select',
  clientManagementHouseholdSelect: 'client_management_household_select',
  clientManagementNonIndividualClientsSelect: 'client_management_non_individual_clients_select_select',
  clientsAccessTabSelect: 'clients_access_tab_select',
  clientsProfileAuditLogTabSelect: 'clients_profile_audit_log_tab_select',
  clientsProfileDetailsTabSelect: 'clients_profile_details_tab_select',
  clientsProfileDocumentsTabSelect: 'clients_profile_documents_tab_select',
  clientsProfileLedgerTabSelect: 'clients_profile_ledger_tab_select',
  clientsProfileNotesTabSelect: 'clients_profile_notes_tab_select',
  clientsProfileOverviewTabSelect: 'clients_profile_overview_tab_select',
  clientsProfileStatementsTabSelect: 'clients_profile_statements_tab_select',
  clientsProfileTradesTabSelect: 'clients_profile_trades_tab_select',
  clientsProfileTransfersTabSelect: 'clients_profile_transfers_tab_select',
  complianceAccountsReviewSelect: 'compliance_accounts_review_select',
  complianceAllTransactionsSelect: 'compliance_all_transactions_select',
  complianceAnnualProfileUpdateSelect: 'compliance_annual_profile_update_select',
  complianceComplianceReviewSelect: 'compliance_compliance_review_select',
  complianceElderlyClientsSelect: 'compliance_elderly_clients_select',
  complianceInstitutionsApprovalSelect: 'compliance_institutions_approval_select',
  complianceNewBankAccountApprovalSelect: 'compliance_new_bank_account_approval_select',
  complianceSuspiciousTransfersSelect: 'compliance_suspicious_transfers_select',
  dashboardBasicSelect: 'dashboard_basic_select',
  dashboardComplianceSelect: 'dashboard_compliance_select',
  dashboardOperationsSelect: 'dashboard_operations_select',
  dashboardOrganizationSelect: 'dashboard_organization_select',
  dashboardPortfolioManagerSelect: 'dashboard_portfolio_manager_select',
  documentsWidgetDocumentDelete: 'documents_widget_document_delete',
  documentsWidgetDocumentDownload: 'documents_widget_document_download',
  documentsWidgetDocumentView: 'documents_widget_document_view',
  documentsWidgetDownloadButtonSelect: 'documents_widget_download_button_select',
  documentsWidgetFilterApply: 'documents_widget_filter_apply',
  documentsWidgetSearch: 'documents_widget_search',
  documentsWidgetTabAgreementsSelect: 'documents_widget_tab_agreements_select',
  documentsWidgetTabClientReportsSelect: 'documents_widget_tab_client_reports_select',
  documentsWidgetTabFormCompletionsSelect: 'documents_widget_tab_form_completions_select',
  documentsWidgetTabStatementsSelect: 'documents_widget_tab_statements_select',
  documentsWidgetTabTaxDocumentsSelect: 'documents_widget_tab_tax_documents_select',
  documentsWidgetTabTradeConfirmationsSelect: 'documents_widget_tab_trade_confirmations_select',
  documentsWidgetTabUploadedDocumentsSelect: 'documents_widget_tab_uploaded_documents_select',
  documentsWidgetUploadButtonSelect: 'documents_widget_upload_button_select',
  feeGridAddComplete: 'fee_grid_add_complete',
  feeGridAddInit: 'fee_grid_add_init',
  feeGridAddSummary: 'fee_grid_add_summary',
  feeGridEditComplete: 'fee_grid_edit_complete',
  feeGridEditInit: 'fee_grid_edit_init',
  feeGridEditSummary: 'fee_grid_edit_summary',
  feesAndBillingBillingSchedulesSelect: 'fees_billing_billing_schedules_select',
  feesAndBillingFeeGridSelect: 'fees_billing_fee_grid_select',
  feesAndBillingFeeReportSelect: 'fees_billing_fee_report_select',
  feesAndBillingIncurredFeeSelect: 'fees_billing_incurred_fee_select',
  feesAndBillingRevenueShareSelect: 'fees_billing_revenue_share_select',
  goalDetailsDepositButtonSelect: 'goal_details_deposit_button_select',
  goalDetailsWithdrawButtonSelect: 'goal_details_withdraw_button_select',
  homepageAccountSelect: 'homepage_account_select',
  homepageContactSupportSelect: 'homepage_contact_support_select',
  homepageContinueInProgressWorkflowSelect: 'homepage_continue_in_progress_workflow_select',
  homepageDepositButtonSelect: 'homepage_deposit_button_select',
  homepageGoalSelect: 'homepage_goal_select',
  homepageProfileSelect: 'homepage_profile_select',
  homepageResourceArticlesSelect: 'homepage_resource_articles_select',
  homepageStartNewWorkflowSelect: 'homepage_start_new_workflow_select',
  homepageWithdrawButtonSelect: 'homepage_withdraw_button_select',
  modelPageCreateBack: 'model_page_create_back',
  modelPageCreateStep1BuildAssetTemplate: 'model_page_create_step1_build_asset_template',
  modelPageCreateStep1BuildScratch: 'model_page_create_step1_build_scratch',
  modelPageCreateStep1Next: 'model_page_create_step1_next',
  modelPageCreateStep2BuildAssetTemplateCreateNew: 'model_page_create_step2_build_asset_template_create_new',
  modelPageCreateStep2BuildAssetTemplateCreateNewCreateUse: 'model_page_create_step2_build_asset_template_create_new_create_use',
  modelPageCreateStep2BuildAssetTemplateCreateNewSaveForLater: 'model_page_create_step2_build_asset_template_create_new_save_for_later',
  modelPageCreateStep2BuildAssetTemplateNext: 'model_page_create_step2_build_asset_template_next',
  modelPageCreateStep3AddModelDetailsSave: 'model_page_create_step3_add_model_details_save',
  modelPageCreateStep4AddIpsAddIps: 'model_page_create_step4_add_ips_add_ips',
  modelPageCreateStep4AddIpsDone: 'model_page_create_step4_add_ips_done',
  modelPageCreateStep4AddIpsSaveLater: 'model_page_create_step4_add_ips_save_later',
  modelPageCreateStep4AddSecurity: 'model_page_create_step4_add_security',
  modelPageCreateStep4Continue: 'model_page_create_step4_continue',
  modelPageCreateStep4DoesntMatchModalCancel: 'model_page_create_step4_doesnt_match_modal_cancel',
  modelPageCreateStep4DoesntMatchModalContinue: 'model_page_create_step4_doesnt_match_modal_continue',
  modelPageCreateStep4SaveLater: 'model_page_create_step4_save_later',
  modelPageEditAssetAllocationSummary: 'model_page_edit_asset_allocation_summary',
  modelPageEditDetailsSummary: 'model_page_edit_details_summary',
  modelPageEditInvestmentPolicyStatementSummary: 'model_page_edit_investment_policy_statement_summary',
  modelPageEditTabAssetAllocation: 'model_page_edit_tab_asset_allocation',
  modelPageEditTabAssetAllocationAddSecurity: 'model_page_edit_tab_asset_allocation_add_sercurity',
  modelPageEditTabAssetAllocationCancelEdit: 'model_page_edit_tab_asset_allocation_cancel_edit',
  modelPageEditTabAssetAllocationDownload: 'model_page_edit_tab_asset_allocation_download',
  modelPageEditTabAssetAllocationEdit: 'model_page_edit_tab_asset_allocation_edit',
  modelPageEditTabAssetAllocationSaveEdit: 'model_page_edit_tab_asset_allocation_save_edit',
  modelPageEditTabAuditLog: 'model_page_edit_tab_audit_log',
  modelPageEditTabAuditLogPageNext: 'model_page_edit_tab_audit_log_page_next',
  modelPageEditTabAuditLogPageNumber: 'model_page_edit_tab_audit_log_page_number',
  modelPageEditTabAuditLogPagePrevious: 'model_page_edit_tab_audit_log_page_previous',
  modelPageEditTabAuditLogRowModalOpen: 'model_page_edit_tab_audit_log_row_modal_open',
  modelPageEditTabDetails: 'model_page_edit_tab_details',
  modelPageEditTabDetailsCancel: 'model_page_edit_tab_details_cancel',
  modelPageEditTabDetailsSave: 'model_page_edit_tab_details_save',
  modelPageEditTabInvestmentPolicyStatement: 'model_page_edit_tab_investment_policy_statement',
  modelPageEditTabInvestmentPolicyStatementAddAssetClass: 'model_page_edit_tab_investment_policy_statement_add_asset_class',
  modelPageEditTabInvestmentPolicyStatementCancel: 'model_page_edit_tab_investment_policy_statement_cancel',
  modelPageEditTabInvestmentPolicyStatementReSigningIps: 'model_page_edit_tab_investment_policy_statement_re_signing_ips',
  modelPageEditTabInvestmentPolicyStatementReSigningIpsCancel: 'model_page_edit_tab_investment_policy_statement_re_signing_ips_cancel',
  modelPageEditTabInvestmentPolicyStatementReSigningIpsSave: 'model_page_edit_tab_investment_policy_statement_re_signing_ips_save',
  modelPageEditTabInvestmentPolicyStatementSave: 'model_page_edit_tab_investment_policy_statement_save',
  modelPageFilterModelFamily: 'model_page_filter_model_family',
  modelPageFilterSearch: 'model_page_filter_search',
  modelPageFilterStatus: 'model_page_filter_status',
  modelPageModelSelect: 'model_page_model_select',
  modelPagePageNext: 'model_page_page_next',
  modelPagePageNumber: 'model_page_page_number',
  modelPagePagePrevious: 'model_page_page_previous',
  modelPageRowButtonCreate: 'model_page_row_button_create',
  modelPageRowEditModel: 'model_page_row_edit_model',
  modelPageRowMoveDraft: 'model_page_row_move_draft',
  modelPageRowSortModelDesc: 'model_page_row_sort_model_desc',
  modelPageRowSortModelFamily: 'model_page_row_sort_model_family',
  modelPageRowSortModelName: 'model_page_row_sort_model_name',
  modelPageRowSortStatus: 'model_page_row_sort_status',
  modelPageUpdatePerPage: 'model_page_update_per_page',
  modelPortfolioWorkflowStep1Complete: 'model_portfolio_workflow_step1_create_model_portfolio_complete',
  modelPortfolioWorkflowStep2Complete: 'model_portfolio_workflow_step2_add_details_complete',
  modelPortfolioWorkflowStep3Complete: 'model_portfolio_workflow_step3_add_securities_complete',
  modelPortfolioWorkflowStep4Complete: 'model_portfolio_workflow_step4_add_ips_and_asset_classes_complete',
  portfolioManagementAssetClassesSelect: 'portfolio_management_asset_classes_select',
  portfolioManagementModelPortfoliosSelect: 'portfolio_management_model_portfolios_select',
  portfolioManagementProductShelfSelect: 'portfolio_management_product_shelf_select',
  portfolioManagementTradingSchedulesSelect: 'portfolio_management_trading_schedules_select',
  portfolioOptimizerDetailCancel: 'portfolio_optimizer_detail_cancel',
  portfolioOptimizerDetailComplete: 'portfolio_optimizer_detail_complete',
  portfolioOptimizerDetailDownload: 'portfolio_optimizer_detail_download',
  portfolioOptimizerDetailError: 'portfolio_optimizer_detail_error',
  portfolioOptimizerDetailSave: 'portfolio_optimizer_detail_save',
  portfolioOptimizerDetailTransition: 'portfolio_optimizer_detail_transition',
  portfolioOptimizerDetailUpdate: 'portfolio_optimizer_detail_update',
  portfolioOptimizerPageListPageNext: 'portfolio_optimizer_page_list_page_next',
  portfolioOptimizerPageListPageNumber: 'portfolio_optimizer_page_list_page_number',
  portfolioOptimizerPageListPagePrevious: 'portfolio_optimizer_page_list_page_previous',
  portfolioOptimizerPageListRowSelect: 'portfolio_optimizer_page_list_row_select',
  portfolioOptimizerPageListRun: 'portfolio_optimizer_page_list_run',
  portfolioOptimizerRunAbandon: 'portfolio_optimizer_run_abandon',
  portfolioOptimizerRunComplete: 'portfolio_optimizer_run_complete',
  portfolioOptimizerRunError: 'portfolio_optimizer_run_error',
  portfolioOptimizerRunInit: 'portfolio_optimizer_run_init',
  portfolioOptimizerRunSummary: 'portfolio_optimizer_run_summary',
  productShelfPageAuditLogFilterDateClear: 'product_shelf_page_audit_log_filter_date_clear',
  productShelfPageAuditLogFilterDateRange: 'product_shelf_page_audit_log_filter_date_range',
  productShelfPageAuditLogFilterFinancialProduct: 'product_shelf_page_audit_log_filter_financial_product',
  productShelfPageAuditLogPageNext: 'product_shelf_page_audit_log_page_next',
  productShelfPageAuditLogPageNumber: 'product_shelf_page_audit_log_page_number',
  productShelfPageAuditLogPagePrevious: 'product_shelf_page_audit_log_page_previous',
  productShelfPageAuditLogRowModalOpen: 'product_shelf_page_audit_log_row_modal_open',
  productShelfPageListDownloadSelected: 'product_shelf_page_list_download_selected',
  productShelfPageListFilterAutoUpdatePrices: 'product_shelf_page_list_filter_auto_update_prices',
  productShelfPageListFilterExchange: 'product_shelf_page_list_filter_exchange',
  productShelfPageListFilterHasSubstituteProducts: 'product_shelf_page_list_filter_has_substitute_products',
  productShelfPageListFilterPlanned: 'product_shelf_page_list_filter_planned',
  productShelfPageListFilterPrimaryAssetClass: 'product_shelf_page_list_filter_primary_asset_class',
  productShelfPageListFilterPrimarySecondaryClass: 'product_shelf_page_list_filter_primary_secondary_class',
  productShelfPageListFilterSearch: 'product_shelf_page_list_filter_search',
  productShelfPageListPageNext: 'product_shelf_page_list_page_next',
  productShelfPageListPageNumber: 'product_shelf_page_list_page_number',
  productShelfPageListPagePrevious: 'product_shelf_page_list_page_previous',
  productShelfPageListSelectAll: 'product_shelf_page_list_select_all',
  productShelfPageListSelectOne: 'product_shelf_page_list_select_one',
  productShelfPageListSelectPage: 'product_shelf_page_list_select_page',
  productShelfPageTabAuditLog: 'product_shelf_page_tab_audit_log',
  productShelfPageTabDetails: 'product_shelf_page_tab_details',
  reportsSelect: 'reports_select',
  systemManagementBulkImportSelect: 'system_management_bulk_import_select',
  systemManagementIntegrationSettingsSelect: 'system_management_integration_settings_select',
  systemManagementOrganizationSettingsSelect: 'system_management_organization_settings_select',
  systemManagementReconciliationSelect: 'system_management_reconciliation_select',
  systemManagementStatementsReviewSelect: 'system_management_statements_review_select',
  tradingBulkTraderSelect: 'trading_bulk_trader_select',
  tradingPortfolioOptimizerSelect: 'trading_portfolio_optimizer_select',
  tradingRebalanceReportV1Select: 'trading_rebalance_report_select',
  tradingRebalancingSelect: 'trading_rebalancing_select',
  tradingSchedulesCreateAbandon: 'trading_schedules_create_abandon',
  tradingSchedulesCreateComplete: 'trading_schedules_create_complete',
  tradingSchedulesCreateError: 'trading_schedules_create_error',
  tradingSchedulesCreateInit: 'trading_schedules_create_init',
  tradingSchedulesCreateSummary: 'trading_schedules_create_summary',
  tradingSchedulesEditAbandon: 'trading_schedules_edit_abandon',
  tradingSchedulesEditComplete: 'trading_schedules_edit_complete',
  tradingSchedulesEditError: 'trading_schedules_edit_error',
  tradingSchedulesEditInit: 'trading_schedules_edit_init',
  tradingSchedulesEditSummary: 'trading_schedules_edit_summary',
  tradingSchedulesPageListCreate: 'trading_schedules_page_list_create',
  tradingSchedulesPageListPageNext: 'trading_schedules_page_list_page_next',
  tradingSchedulesPageListPageNumber: 'trading_schedules_page_list_page_number',
  tradingSchedulesPageListPagePrevious: 'trading_schedules_page_list_page_previous',
  tradingTLHSelect: 'trading_tlh_select',
  workflowAgreementsContinueButtonSelect: 'workflow_agreements_continue_button_select',
  workflowsAddModelPortfolioDetailsContinueButtonSelect: 'workflows_add_model_portfolio_details_continue_button_select',
  workflowsAssignPortfolioToSubAccountContinueButtonSelect: 'workflows_assign_portfolio_to_sub_account_continue_button_select',
  workflowsCollectSignersSendButtonSelect: 'workflows_collect_signers_send_button_select',
  workflowsCompletionEnd: 'workflows_completion_end',
  workflowsCompletionStart: 'workflows_completion_start',
  workflowsCreateAccountContinueButtonSelect: 'workflows_create_account_continue_button_select',
  workflowsCreateAccountForGoalContinueButtonSelect: 'workflows_create_account_for_goal_continue_button_select',
  workflowsCreateGoalContinueButtonSelect: 'workflows_create_goal_continue_button_select',
  workflowsCreateModelPortfolioContinueButtonSelect: 'workflows_create_model_portfolio_continue_button_select',
  workflowsDocumentsContinueButtonSelect: 'workflows_documents_continue_button_select',
  workflowsEditAccountContinueButtonSelect: 'workflows_edit_account_continue_button_select',
  workflowsEditGoalContinueButtonSelect: 'workflows_edit_goal_continue_button_select',
  workflowsEmploymentInformationContinueButtonSelect: 'workflows_employment_information_continue_button_select',
  workflowsGoalRiskQuestion1ContinueButtonSelect: 'workflows_goal_risk_question_1_continue_button_select',
  workflowsIdVerificationContinueButtonSelect: 'workflows_id_verification_continue_button_select',
  workflowsIncomeAssetsAndDebtsContinueButtonSelect: 'workflows_income_assets_and_debts_continue_button_select',
  workflowsInvestmentKnowledgeContinueButtonSelect: 'workflows_investment_knowledge_continue_button_select',
  workflowsNonIndividualInformationContinueButtonSelect: 'workflows_non_individual_information_continue_button_select',
  workflowsNonIndividualSetupContinueButtonSelect: 'workflows_non_individual_setup_continue_button_select',
  workflowsPersonalInformationContinueButtonSelect: 'workflows_personal_information_continue_button_select',
  workflowsPersonOfInterestContinueButtonSelect: 'workflows_person_of_interest_continue_button_select',
  workflowsProjectionsContinueButtonSelect: 'workflows_projections_continue_button_select',
  workflowsRelationshipInformationContinueButtonSelect: 'workflows_relationship_information_continue_button_select',
  workflowsResidencyInformationContinueButtonSelect: 'workflows_residency_information_continue_button_select',
  workflowsReviewAccountContinueButtonSelect: 'workflows_review_account_continue_button_select',
  workflowsReviewContinueButtonSelect: 'workflows_review_continue_button_select',
  workflowsReviewGoalContinueButtonSelect: 'workflows_review_goal_continue_button_select',
  workflowsRiskQuestion1ContinueButtonSelect: 'workflows_risk_question_1_continue_button_select',
  workflowsRiskQuestion2ContinueButtonSelect: 'workflows_risk_question_2_continue_button_select',
  workflowsSelectPortfolioTemplateContinueButtonSelect: 'workflows_select_portfolio_template_continue_button_select',
  workflowsSelectPortfolioTemplateCreateNewButtonSelect: 'workflows_select_portfolio_template_create_new_button_select',
  workflowsTransfersContinueButtonSelect: 'workflows_transfers_continue_button_select',
} as const;

export const analyticsEventMap = Object.freeze(analyticsEventMapLiteral);

export type AnalyticsEventKey = keyof typeof analyticsEventMapLiteral;
export type AnalyticsEventName = (typeof analyticsEventMapLiteral)[AnalyticsEventKey];

export const analyticsEventKeys = Object.freeze(Object.keys(analyticsEventMapLiteral) as AnalyticsEventKey[]);

export type AnalyticsEventDictionary = typeof analyticsEventMapLiteral;

export default analyticsEventMap;
